import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useMemo } from 'react';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Menu,
  MenuItem,
  Box
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store.js';
import { getUserList, deleteUser } from 'src/redux/slices/user.js';
// import { UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';

// routes
// components
import Page from 'src/components/Page.js';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Label from 'src/components/Label.js'; 
import Scrollbar from 'src/components/Scrollbar.js';
import SearchNotFound from 'src/components/SearchNotFound.js';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';
import  ProjectListViewToolbar  from 'src/components/_dashboard/user/list/ProjectListViewToolbar';
import  ProjectListMenu  from 'src/components/_dashboard/user/list/ProjectListMenu';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import LoadingScreen from 'src/components/LoadingScreen';
import ConfirmationPopup from '../official-request/ConfirmationPopup';
import FullScreenDialogsAllJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import quickbookLogo from '../../../assets/quickbookLogo-removebg-preview.png'

import { Form, Formik, FormikProvider } from 'formik';
import Modal from './ProjectModel';

// ----------------------------------------------------------------------

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Accepted' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]

  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]
  
  
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const onboard_data=[
    {
        id:0,
        status:'Pending',
        name:'Laffety',
        number:'123456789',
        address:'California',
        total:'23925.00 USD',
        createdon:'12/31/1969',
    },
    {
        id:1,
        status:'Pending',
        name:'K Hovnanian',
        number:'6532611678',
        address:'Manteca',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:2,
        status:'Pending',
        name:'Chase Brendle',
        number:'1215165265',
        address:'San Francisco',
        total:'24480.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:3,
        status:'Pending',
        name:'Jane Doe',
        number:'281728173',
        address:'Sedona',
        total:'68206.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:4,
        status:'Pending',
        name:'Adam Sandler',
        number:'3152614141',
        address:'Miami',
        total:'14280.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:5,
        status:'Pending',
        name:'Umila Garib',
        number:'2728738268',
        address:'West Palm Beach',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
]

export default function UsersListV({ user, team,  isVendor, projectData, setRenderCards, renderCards, isLoading, projectId, setProjectId, openViewPage, setOpenViewPage, projectName, setProjectName, removePopupData, HandleViewProfile, setRefreshClient, noImage,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    fromClient,
    order: parentOrder,
    orderBy: parentOrderBy,
    onRequestSort: parentOnRequestSort,
    serverSideSort = false
}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const UsersListV = onboard_data; // Replaced UsersListV with onboard_data
//   const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  
  // Use parent sort state if server-side sorting is enabled
  const currentOrder = serverSideSort ? parentOrder : order;
  const currentOrderBy = serverSideSort ? parentOrderBy : orderBy;
  const [filterName, setFilterName] = useState('');
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  const [isDelete,setIsDelete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [deleteId,setDeleteId] = useState(null);
   const [deleteTeam, setDeleteTeam] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);
     const [setectedRow, setSelectedRow] = useState(null);
     console.log('setectedRow=====================', setectedRow)
  let userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const handleClose = () => {
    setAnchorEl(null);
  };
  const TABLE_HEAD = [
    { id: 'name', label:  'Name', alignRight: false },
    ...((isVendor || team)
      ? []
      : [{ id: 'customer_type_name', label: 'Customer Type', alignRight: false }]),
    { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false }])
  ];
  const TABLE_HEAD2 = [
    { id: 'image', label: 'Profile Image', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    ...((isVendor || team)
      ? []
      : [{ id: 'customer_type_name', label: 'Customer Type', alignRight: false }]),
    { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false }])   

  ];
    const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { 
        color: 'primary',
        //  label: 'Status: Open'
         label: ' Open'
         }
    default:
      return { color: 'default', label: 'Pending' }
  }
}
  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Rest of the code remains unchanged from here
  // ...
  const handleRequestSort = (event, property) => {
    if (serverSideSort && parentOnRequestSort) {
      // Use parent's sort handler for server-side sorting
      parentOnRequestSort(event, property);
    } else {
      // Use local sort handler for client-side sorting
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = UsersListV.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const sortedData = useMemo(() => {
    if (!projectData || projectData.length === 0) return projectData;
    
    // If server-side sorting is enabled, data is already sorted from the server
    if (serverSideSort) {
      return projectData;
    }
    
    // Client-side sorting
    const stabilizedThis = projectData.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      let aValue = a[0][currentOrderBy];
      let bValue = b[0][currentOrderBy];
      
      // Handle null/undefined values
      if (aValue == null) aValue = '';
      if (bValue == null) bValue = '';
      
      // For string fields, use localeCompare for proper alphabetical sorting
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const comparison = aValue.localeCompare(bValue, undefined, { numeric: true, sensitivity: 'base' });
        return currentOrder === 'asc' ? comparison : -comparison;
      }
      
      // For other types, use standard comparison
      if (bValue < aValue) {
        return currentOrder === 'asc' ? 1 : -1;
      }
      if (bValue > aValue) {
        return currentOrder === 'asc' ? -1 : 1;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }, [projectData, currentOrder, currentOrderBy, serverSideSort]);

  const emptyRows = sortedData.length > 0 ? 0 : 2;
  
  const isUserNotFound = sortedData?.length === 0;
  const handleClickOpenViewPage=(id,name)=>{
    setProjectId(id)
    setProjectName(name)
    setOpenViewPage(true)
    localStorage.setItem("openProductionPopup", "true");
    localStorage.setItem("projectId", id);
    localStorage.setItem("projectName", name);
    
    // setSearchParams({
    //   open: "true",
    //   // view: "viewPage",
    //   // projectId: id,
    //   // projectName: name,
    // });
  }
  const changeStatus = async (teamId, teamStatus) => {
    try {
      let status = teamStatus;
      let userId = userData.user_id
    
      let response = await axios.post(`${REST_API_END_POINT}teams/delete-team-members`,
        { teamId, status, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
    
      if (response.data.status === 1) {
        setDeleteId('');
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: teamId } });
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      else {
       
        enqueueSnackbar("Error.........!", { variant: 'error' });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }
   const handleDeleteClient=async(id,status)=>{
     try {
      const data={id:id,status:status}
      const res = await axios.post(`${REST_API_END_POINT}clients/remove-client`,data)
      console.log(res.data)
       if(res.data.status ==1){
        setDeleteId('');
        setDeleteTeam(false);
        setRefreshClient((prev)=>!prev)
       enqueueSnackbar(res.data.message,{variant:'success'})
       }else if(res.data.status ==0){
        setDeleteId('');
        enqueueSnackbar(res.data.message,{variant:'error'})
       }
     } catch (error) {
       console.log(error,'Error in deleting client')
     }
   }
  return (
<>
      <Grid container spacing={3}>
        {isLoading ? <LoadingScreen /> :
          <Grid item xs={12}>
            <Card>
              {/* <ProjectListViewToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
  
              <Scrollbar>
                <TableContainer 
                  sx={{ 
                    minWidth: 800, 
                    whiteSpace: "nowrap", 
                    overflowX: "auto",
                    maxHeight: "500px",  // Set a max height to allow scrolling
                    overflowY: "auto",  // Enable vertical scrollbar
                    '&::-webkit-scrollbar': {
                      width: '0.6em',
                      height: '0.6em',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#1e1e1e', // dark background to blend with dark UI
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#555', // medium-gray thumb
                      borderRadius: '6px',
                      border: '2px solid #1e1e1e', // contrast border to separate from track
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#888', // lighter on hover for feedback
                    },
                    '&::-webkit-scrollbar-corner': {
                      backgroundColor: '#1e1e1e' // match your dark background
                    },
                  }}
                >
                  <Table 
                    stickyHeader
                    sx={{
                      '& .MuiTableCell-head': {
                        padding: '8px 12px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        height: '48px',
                        minHeight: '48px',
                        maxHeight: '48px',
                        lineHeight: 1.4,
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                        verticalAlign: 'middle'
                      },
                      '& .MuiTableSortLabel-root': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        justifyContent: 'flex-start',
                        '& .MuiTableSortLabel-icon': {
                          marginLeft: '4px'
                        }
                      }
                    }}
                  >
                    <UserListHead
                      order={currentOrder}
                      orderBy={currentOrderBy}
                      headLabel={noImage ?TABLE_HEAD:TABLE_HEAD2}
                      rowCount={sortedData?.length}
                      numSelected={selected?.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      // checkboxPresent={true}
                    />
                    <TableBody>
                      {sortedData?.map((row) => {
                        console.log('row===============================', row)
                        const status = Number(row.status)
                        const hold = Number(row.hold)
                        const Newimage = (row.profile_pic && row.profile_pic!='avatar.jpg') ? row.profile_pic: (team ? `${row.first_name}${row.last_name}`  : row.name) ;
                        const Newname = team ? `${row.first_name}${row.last_name}`  : row.name ;
                        return (
                          <TableRow
                            hover
                            key={0}
                            sx={{
                              '& .MuiTableCell-root': {
                                padding: '8px 12px',
                                fontSize: '0.75rem',
                                height: 'auto',
                                lineHeight: 1.4
                              }
                            }}
                          >
                            {/* <TableCell padding="checkbox">
                              <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                            </TableCell> */}
                                <TableCell align="left" sx={{ padding: '8px 4px !important', width: '40px' }}>
                                    <Box sx={{ width: '100%', display: "flex", justifyContent: "flex-start", height: "30px",width:"50px", mt: 2 }}>
                                        {
                                            row.syncWithQuickBook === 1 ?
                                                <img src={quickbookLogo} width={"50px"} height={"30px"} />
                                                : ""
                                        }
                                    </Box>
                                </TableCell>
                                {!noImage&&<TableCell align="left" sx={{ padding: '8px 12px' }}>
                                    <Avatar
                                    alt={Newname}
                                        src={Newimage || 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                                        sx={{
                                            width: '40px',
                                            height: '40px',
                                            // borderRadius: '5px',
                                            margin: '0', // Left align the image
                                            // display: 'block', // Ensure block-level display for margin to work
                                            // objectFit: 'fill',
                                        }}
                                    />
                                </TableCell>}
                            {/* <TableCell align="center">{row.request_id}</TableCell> */}
                                <TableCell align="left" sx={{
                                    padding: '8px 12px',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                    },
                                }} 
                              onClick={() => {
                                HandleViewProfile(row,row.id, Newname);
                                // if (communityJob) {
                                //   navigate(PATH_DASHBOARD.project.viewproject + row.id, { state: { fromCommunityJob: true } });
                                // } else {
                                //   handleClickOpenViewPage(row.id, row.name);
                                // }
                              }}                              
                              >{Newname}
                              </TableCell>
                            {(isVendor || team) ? '' : <TableCell align="left" sx={{ padding: '8px 12px' }}>{row.customer_type_name}</TableCell>}
                            {/* <TableCell align="center">{row.community_name}</TableCell>
                            <TableCell align="center">{row.authorized_by}</TableCell>
                            <TableCell align="center">{row.member_count}</TableCell> */}
                            {/* <TableCell align="center">{row.city==='DefaultCity' ? '' : row.city}</TableCell> */}
                            
                            <TableCell align="left" sx={{ padding: '8px 12px' }}>
                            <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={getStatusColorAndLabel(status).color} >
                                {getStatusColorAndLabel(status).label}
                            </Label>
                            </TableCell>
                                <TableCell align="left" sx={{ padding: '8px 12px' }}>
                                    {(!team && status) ? (
                                        <UserMoreMenu
                                            onEdit={() => {
                                                HandleViewProfile(row,row.id, team ? row.first_name + " " + row.last_name : row.name, 'edit');
                                                handleClose()
                                            }}
                                            disabled={row?.isVendor ? (explodedPermissions?.some(permission => ['Edit Vendors'].includes(permission)) ? false : true)
                                                : (explodedPermissions?.some(permission => ['Edit clients'].includes(permission)) ? false : true)}
                                            onDelete={() => {
                                                setDeleteTeam(!deleteTeam);
                                                setAnchorEl(null);
                                                setDeleteId(row.id);
                                                setSelectedRow(row)
                                            }}
                                            Deletedisabled={team
                                                ? (userData?.user_type === 3
                                                    ? false
                                                    : !(explodedPermissions?.some(permission => ['Delete team members'].includes(permission)))
                                                )
                                                : (row?.isVendor
                                                    ? (explodedPermissions?.some(permission => ['Delete Vendors'].includes(permission)) ? false : true)
                                                    : (explodedPermissions?.some(permission => ['Delete clients'].includes(permission)) ? false : true)
                                                )}

                                        />) : (
                                        <UserMoreMenu
                                            onDelete={() => {
                                                setDeleteTeam(!deleteTeam);
                                                setAnchorEl(null);
                                                setDeleteId(row.id);
                                                setSelectedRow(row)
                                            }}
                                            Deletedisabled={team
                                                ? (userData?.user_type === 3
                                                    ? false
                                                    : !(explodedPermissions?.some(permission => ['Delete team members'].includes(permission)))
                                                )
                                                : (row?.isVendor
                                                    ? (explodedPermissions?.some(permission => ['Delete Vendors'].includes(permission)) ? false : true)
                                                    : (explodedPermissions?.some(permission => ['Delete clients'].includes(permission)) ? false : true)
                                                )}

                                        />)
                                    }
                                </TableCell>
                          </TableRow>
                        );
                      
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
  
              <TablePagination
                rowsPerPageOptions={[6, 12, 27, 39]}
                component="div"
                 count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
           
          </Grid>
        }
        
      </Grid>
      <FullScreenDialogsAllJobs
      initialFromCalender={"false"}
            open={openViewPage}
            removePopupData={removePopupData}
            setOpen={setOpenViewPage}
            renderCards={renderCards}
            handleClickOpen={handleClickOpenViewPage}
            projectName={projectName}
            projectId={projectId}
            setRenderCards={setRenderCards}
            />
             <Modal
                    open={deleteTeam}
                    handleClose={() => {
                      setDeleteTeam(false);
                    }}
                  // modalTitle={'Remove Team Member'}
                  >
                    <FormikProvider value={Formik}>
                      <Form noValidate autoComplete="off">
                        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                          <Avatar
                            alt={team ? setectedRow?.first_name + " " + setectedRow?.last_name:setectedRow?.name}
                            src={team ? setectedRow?.profile_pic ? setectedRow?.profile_pic : setectedRow?.first_name:  setectedRow?.profile_pic ? setectedRow?.profile_pic : setectedRow?.name }
                            sx={{ width: 150, height: 150, margin: "auto", }}
                          />
                          <Typography variant="h5" sx={{ color: 'primary.secondary', alignSelf: 'center' }}>
                            Are you sure you want to delete {team ? setectedRow?.first_name + " " + setectedRow?.last_name:setectedRow?.name} ?</Typography>
                        </Stack>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid item xs={12} md={6}>
                            <Box sx={{ my: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                              <Button variant="contained"
                                onClick={() => {
                                  if(fromClient !== true){
                                    setDeleteTeam(false);
                                    changeStatus(deleteId, 2);
                                  // navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: deleteId } });
                                  }else{
                                    handleDeleteClient(deleteId,2)
                                    
                                  }
                                }}>
                                Yes, Delete it!
                              </Button>
                              <Button variant="outlined" onClick={() => {
                                setDeleteTeam(false);
                              }}>
                                No, Cancel pls!
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    </FormikProvider>
                  </Modal>
</>
  );
}
